import { Mock } from "@interfaces/Mock";
import { BASE_URL, CLOUDINARY_URL } from "@/constants";
import { getIsoDate } from "@/utils/date";
const axios = require("axios");

export class Prod extends Mock {
  login(payload = {}) {
    return new Promise(async (resolve) => {
      try {
        const { data = {} } = await axios.post(
          BASE_URL + "/api/usuarios/authenticate",
          payload
        );
        resolve({ ok: true, result: data });
      } catch (error) {
        resolve({ ok: false, error });
      }
    });
  }

  logout() {
    return new Promise(async (resolve) => {
      try {
        resolve({ ok: true });
      } catch (error) {
        resolve({ ok: false, error });
      }
    });
  }

  updateUserTable(id = "", payload = {}) {
    return new Promise(async (resolve) => {
      try {
        const { data = {} } = await axios.put(
          BASE_URL + "/api/usuarios/" + id,
          payload
        );
        resolve({ ok: true, result: data });
      } catch (error) {
        resolve({ ok: false, error });
      }
    });
  }

  reportTable({ placeId = "", mesa = "" }) {
    return new Promise(async (resolve) => {
      try {
        const { data = {} } = await axios.put(
          BASE_URL + "/api/puestos/" + placeId + "/" + mesa,
          { reportada: true }
        );
        resolve({ ok: true, result: data });
      } catch (error) {
        resolve({ ok: false, error });
      }
    });
  }

  getCandidates({ placeId = "", table = "" }) {
    return new Promise(async (resolve) => {
      try {
        const { data = {} } = await axios.get(
          BASE_URL + "/api/puestos/" + placeId + "/" + table
        );
        resolve({ ok: true, result: data });
      } catch (error) {
        resolve({ ok: false, error });
      }
    });
  }

  setVotes(votes, { placeId = "", table = "" }) {
    return new Promise(async (resolve) => {
      try {
        const { data = {} } = await axios.put(
          BASE_URL + "/api/puestos/" + placeId + "/" + table,
          votes
        );
        resolve({ ok: true, result: data });
      } catch (error) {
        resolve({ ok: false, error });
      }
    });
  }

  uploadFile({ file, path, table }) {
    const formData = new FormData();
    const date = new Date();
    formData.append("file", file);
    formData.append("public_id", `mesa_${table}_${getIsoDate(date)}`);
    formData.append("upload_preset", "gevbitql");
    formData.append("folder", path);
    return new Promise(async (resolve) => {
      try {
        const { data = {} } = await axios.post(CLOUDINARY_URL, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        resolve({ ok: true, result: data });
      } catch (error) {
        resolve({ ok: false, error });
      }
    });
  }
}
